import { graphql } from '@/gql';

export const FetchResults = graphql(`
    query FetchResults(
        $pagination: Pagination
        $filter: AssessmentResultFilterRule
        $sort: AssessmentResultSortingRule
    ) {
        assessmentResults(pagination: $pagination, filter: $filter, sort: $sort) {
            count
            items {
                ...ResultsListItemData
            }
        }
    }
`);

const ResultsListItemData = graphql(`
    fragment ResultsListItemData on AssessmentResult {
        id
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
                roleAssignments {
                    ... on RoleAssignment {
                        ...RoleAssignment
                    }
                }
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        moduleInstanceId
        moduleInstance {
            name
        }
        assessmentRunId
        assessmentRun {
            name
            startDate
            endDate
            program {
                name
            }
            subGroupIds
            groupId
        }
        result {
            __typename
            ... on SartResult {
                ...ResultSartResult
            }
            ... on SpatialPlanningResult {
                ...ResultSpatialPlanningResult
            }
            ... on VisualReactionResult {
                ...ResultVisualReactionResult
            }
            ... on ML360Result {
                ...ResultML360Result
            }
            ... on SelfDeterminationResult {
                ...ResultSelfDeterminationResult
            }
            ... on TeamResilienceResult {
                ...ResultTeamResilienceResult
            }
            ... on NBackResult {
                ...ResultNBackResult
            }
        }
        completedAt
    }
`);

export const FetchResultsPrograms = graphql(`
    query FetchResultsPrograms($filter: ProgramFilteringRule) {
        programs(filter: $filter) {
            count
            items {
                ...ResultsProgramItemData
            }
        }
    }
`);

const ResultsProgramItemData = graphql(`
    fragment ResultsProgramItemData on Program {
        id
        name
        description

        assessmentRuns {
            ...ResultsAssessmentRunData
        }

        courseInstance {
            executionSequence {
                moduleInstanceId
                order
                moduleInstance {
                    ...AssessmentResultModuleInstanceData
                }
            }
        }
    }
`);

const ResultsAssessmentRunData = graphql(`
    fragment ResultsAssessmentRunData on AssessmentRun {
        id
        name
        status
        subGroups {
            id
            name
        }
        group {
            id
            name
        }
    }
`);

export const ExportResults = graphql(`
    query ExportResults(
        $assessmentRunIds: [ObjectID!]!
        $resultType: AssessmentResultType!
        $subgroupIds: [ObjectID!]
        $groupIds: [ObjectID!]
        $searchText: String
        $isExcludeDescriptionRow: Boolean
        $moduleId: ObjectID
    ) {
        exportAssessmentResults(
            assessmentRunIds: $assessmentRunIds
            resultType: $resultType
            subgroupIds: $subgroupIds
            groupIds: $groupIds
            searchText: $searchText
            isExcludeDescriptionRow: $isExcludeDescriptionRow
            moduleId: $moduleId
        ) {
            ... on ExportAssessmentResultSuccessfulResponse {
                result {
                    downloadUrl
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
